'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/RadioButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButton = exports.RadioButton = function (_BcReactComponent) {
  _inherits(RadioButton, _BcReactComponent);

  function RadioButton(props) {
    _classCallCheck(this, RadioButton);

    var _this = _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call(this, props));

    _this.bindAll('handleChange');
    return _this;
  }

  _createClass(RadioButton, [{
    key: 'handleChange',
    value: function handleChange() {
      var _props = this.props,
          handleChange = _props.handleChange,
          value = _props.value;

      handleChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          label = _props2.label,
          description = _props2.description,
          id = _props2.id,
          inputProps = _objectWithoutProperties(_props2, ['label', 'description', 'id']);

      return _react2.default.createElement(
        'div',
        { className: 'cp-radio-button' },
        _react2.default.createElement('input', _extends({ id: id, type: 'radio' }, inputProps, { onChange: this.handleChange })),
        _react2.default.createElement(
          'label',
          { htmlFor: id },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: 'description' },
          description
        )
      );
    }
  }]);

  return RadioButton;
}(_baseBcReactComponent2.default);

RadioButton.propTypes = {
  id: _react2.default.PropTypes.string,
  value: _react2.default.PropTypes.string,
  name: _react2.default.PropTypes.string.isRequired,
  label: _react2.default.PropTypes.string,
  description: _react2.default.PropTypes.string,
  handleChange: _react2.default.PropTypes.func.isRequired,
  checked: _react2.default.PropTypes.bool.isRequired
};

exports.default = RadioButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-radio-button/lib/components/RadioButton.component.js
// module id = 1193
// module chunks = 0